

import React, { useState, useEffect } from 'react';
import { TextField, Button, makeStyles, Typography, Checkbox, FormControlLabel } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
      padding: "2rem"
    },
    input: {
      margin: theme.spacing(1),
      width: '200px'
    },
    dayContainer: {
      margin: theme.spacing(2, 0),
    },
    timeContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    addButton: {
      marginLeft: theme.spacing(2),
    }
}));


const DAYS = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

const normalizeStatus = (status) => {
  const normalized = typeof status === 'string' ? status.trim().toLowerCase() : '';
  if (normalized === 'ouvert' || normalized === 'open') {
    return 'ouvert';
  }
  return 'fermé';
};

const normalizeDayKey = (key) => {
  const normalizedKey = typeof key === 'string' ? key.trim().toLowerCase() : '';
  const match = DAYS.find((day) => day.toLowerCase() === normalizedKey);
  return match || key;
};

const normalizeTimeSlots = (slots) => {
  if (!Array.isArray(slots)) {
    return [];
  }
  return slots.map((slot) => ({
    ouverture: slot?.ouverture || '',
    fermeture: slot?.fermeture || '',
  }));
};

const normalizeHoursShape = (rawHours = {}) => {
  const normalized = {};

  Object.entries(rawHours).forEach(([key, value]) => {
    const normalizedKey = normalizeDayKey(key);
    const horaires = normalizeTimeSlots(value?.horaires);
    const statut = horaires.length > 0 ? 'ouvert' : normalizeStatus(value?.statut);
    normalized[normalizedKey] = {
      statut,
      horaires,
    };
  });

  DAYS.forEach((day) => {
    if (!normalized[day]) {
      normalized[day] = { statut: 'fermé', horaires: [] };
    }
  });

  return normalized;
};

const buildDefaultHours = () =>
  DAYS.reduce((acc, day) => {
    acc[day] = { statut: 'fermé', horaires: [] };
    return acc;
  }, {});

function EstablishmentHours({ initialHours, onHoursChange }) {
  const classes = useStyles();
  // const [hours, setHours] = useState(initialHours);
  const [hours, setHours] = useState(() => buildDefaultHours());

  // Initialiser les horaires pour chaque jour de la semaine
  useEffect(() => {
    // const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
    // const updatedHours = { ...hours };
    // days.forEach(day => {
    //   if (!updatedHours[day]) {
    //     updatedHours[day] = { statut: "fermé", horaires: [] };
    //   }
    // });
    // setHours(updatedHours);
    setHours(normalizeHoursShape(initialHours));
  }, [initialHours]);

  const emitChange = (updatedHours) => {
    setHours(updatedHours);
    if (typeof onHoursChange === 'function') {
      onHoursChange(updatedHours);
    }
  };

  const handleStatusChange = (day, isOpen) => {
    // const newStatus = isOpen ? "ouvert" : "fermé";
    // const newHours = isOpen ? { statut: newStatus, horaires: [{ouverture: "", fermeture: ""}] } : { statut: newStatus, horaires: [] };
    // setHours({ ...hours, [day]: newHours });
    // onHoursChange({ ...hours, [day]: newHours });

    const dayHours = hours[day] || { statut: 'fermé', horaires: [] };
    const updatedDayHours = isOpen
      ? {
          statut: 'ouvert',
          horaires:
            dayHours.horaires.length > 0
              ? normalizeTimeSlots(dayHours.horaires)
              : [{ ouverture: '', fermeture: '' }],
        }
      : { statut: 'fermé', horaires: [] };

    emitChange({ ...hours, [day]: updatedDayHours });
  };

  const handleHoursChange = (day, index, timeType, value) => {
    // const newHours = { ...hours[day] };
    // newHours.horaires[index][timeType] = value;
    // setHours({ ...hours, [day]: newHours });
    // onHoursChange({ ...hours, [day]: newHours });

    const dayHours = hours[day] || { statut: 'fermé', horaires: [] };
    const updatedSlots = dayHours.horaires.map((slot, slotIndex) =>
      slotIndex === index ? { ...slot, [timeType]: value } : slot
    );
    const updatedDayHours = {
      ...dayHours,
      statut: 'ouvert',
      horaires: updatedSlots,
    };

    emitChange({ ...hours, [day]: updatedDayHours });
  };

  const addTimeSlot = (day) => {
    // // S'assurer que les horaires pour le jour spécifié sont initialisés
    // if (!hours[day] || !Array.isArray(hours[day].horaires)) {
    //   // Initialiser les horaires pour ce jour si ce n'est pas déjà fait
    //   setHours({
    //     ...hours,
    //     [day]: { statut: "ouvert", horaires: [{ ouverture: "", fermeture: "" }] }
    //   });
    // } else {
    //   // Ajouter un nouveau créneau horaire au tableau existant
    //   const newHours = { ...hours[day] };
    //   newHours.horaires.push({ ouverture: "", fermeture: "" });
    //   setHours({ ...hours, [day]: newHours });
    //   onHoursChange({ ...hours, [day]: newHours });
    // }

    const dayHours = hours[day] || { statut: 'fermé', horaires: [] };
    const updatedSlots = [...(dayHours.horaires || []), { ouverture: '', fermeture: '' }];
    const updatedDayHours = {
      statut: 'ouvert',
      horaires: updatedSlots,
    };

    emitChange({ ...hours, [day]: updatedDayHours });
  };

  const removeTimeSlot = (day, index) => {
    // const newHours = { ...hours[day] };
    // newHours.horaires.splice(index, 1);
    // setHours({ ...hours, [day]: newHours });
    // onHoursChange({ ...hours, [day]: newHours });

    const dayHours = hours[day] || { statut: 'fermé', horaires: [] };
    const updatedSlots = dayHours.horaires.filter((_, slotIndex) => slotIndex !== index);
    const updatedDayHours = {
      ...dayHours,
      horaires: updatedSlots,
    };

    emitChange({ ...hours, [day]: updatedDayHours });
  };

  return (
    <div className={classes.root}>
      <Typography variant="h4" component="h1" className={classes.title}>
        Horaires de l'établissement
      </Typography>
      {/* {Object.keys(hours).map((day) => (
        <div key={day} className={classes.dayContainer}>
          <FormControlLabel
            control={
              <Checkbox
                checked={hours[day].statut === "ouvert"}
                onChange={(e) => handleStatusChange(day, e.target.checked)}
              />
            }
            label={day}
          />
          {hours[day].statut === "ouvert" && Array.isArray(hours[day].horaires) &&
            hours[day].horaires.map((plage, index) => (
              <div key={index} className={classes.timeContainer}>
                <TextField
                  type="time" 
                  value={plage.ouverture}
                  onChange={(e) => handleHoursChange(day, index, 'ouverture', e.target.value)}
                  label="Heure d'ouverture"
                  variant="outlined"
                  className={classes.input}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  type="time" 
                  value={plage.fermeture}
                  onChange={(e) => handleHoursChange(day, index, 'fermeture', e.target.value)}
                  label="Heure de fermeture"
                  variant="outlined"
                  className={classes.input} */}

{DAYS.map((day) => {
        const dayHours = hours[day] || { statut: 'fermé', horaires: [] };
        return (
          <div key={day} className={classes.dayContainer}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={dayHours.statut === 'ouvert'}
                  onChange={(e) => handleStatusChange(day, e.target.checked)}
                />
      //           <Button
      //             variant="contained"
      //             color="secondary"
      //             onClick={() => removeTimeSlot(day, index)}
      //             InputLabelProps={{ shrink: true }}
      //           >
      //             Supprimer
      //           </Button>
      //         </div>
      //       ))
      //     }
      //     {hours[day].statut === "ouvert" && (
      //       <Button
      //         variant="contained"
      //         color="primary"
      //         className={classes.addButton}
      //         onClick={() => addTimeSlot(day)}
      //       >
      //         Ajouter un créneau horaire
      //       </Button>
      //     )}
      //   </div>
      // ))}

    }
    label={day}
  />
  {dayHours.statut === 'ouvert' &&
    Array.isArray(dayHours.horaires) &&
    dayHours.horaires.map((plage, index) => (
      <div key={index} className={classes.timeContainer}>
        <TextField
          type="time"
          value={plage.ouverture}
          onChange={(e) => handleHoursChange(day, index, 'ouverture', e.target.value)}
          label="Heure d'ouverture"
          variant="outlined"
          className={classes.input}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          type="time"
          value={plage.fermeture}
          onChange={(e) => handleHoursChange(day, index, 'fermeture', e.target.value)}
          label="Heure de fermeture"
          variant="outlined"
          className={classes.input}
        />
        <Button
          variant="contained"
          color="secondary"
          onClick={() => removeTimeSlot(day, index)}
          InputLabelProps={{ shrink: true }}
        >
          Supprimer
        </Button>
      </div>
    ))}
  {dayHours.statut === 'ouvert' && (
    <Button
      variant="contained"
      color="primary"
      className={classes.addButton}
      onClick={() => addTimeSlot(day)}
    >
      Ajouter un créneau horaire
    </Button>
  )}
</div>
);
})}
    </div>
  );
}

export default EstablishmentHours;

